var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment-timezone';
import { defaultDays, defaultHours } from '../../lead-generation/shared/domain/WorkingHours';
import { IvrService } from '../ivr.service';
import { NotificationService } from '../../shared/notification.service';
import { AmplitudeService } from '../../shared/services/amplitude.service';
import { Ng1ModalService } from '../../shared/ng1/ng1-modal.service';
var IvrDetailsComponent = /** @class */ (function () {
    function IvrDetailsComponent(formBuilder, route, ivrService, router, notificationService, amplitudeService, ng1ModalService) {
        var _this = this;
        this.formBuilder = formBuilder;
        this.route = route;
        this.ivrService = ivrService;
        this.router = router;
        this.notificationService = notificationService;
        this.amplitudeService = amplitudeService;
        this.ng1ModalService = ng1ModalService;
        this.workingHoursFormWrapper = { form: null };
        this.allAvailableMsisdns = [];
        this.assignedMsisdns = [];
        this.atLeastOneFileValidator = function (formGroup) {
            return (_this.isCreatingNewIvr
                ? formGroup.get('menus.0').get('greetingFileId').value
                : formGroup.get('menus.0').get('greetingFileName').value || formGroup.get('menus.0').get('greetingFileId').value)
                ? null
                : { fileRequired: true };
        };
    }
    IvrDetailsComponent.prototype.ngOnInit = function () {
        this.assignedMsisdns = this.route.snapshot.data['assignedMsisdns'] || [];
        this.allAvailableMsisdns = this.route.snapshot.data['msisdns'];
        this.isCreatingNewIvr = !this.route.snapshot.data['ivr'];
        this.redirectUrl = this.route.snapshot.queryParams['redirectTo'];
        this.msisdnId = this.route.snapshot.queryParams['msisdnId'];
        if (this.isCreatingNewIvr) {
            this.initEmptyForm();
        }
        else {
            this.initFormFromData(this.ivr);
        }
        this.handleWorkingHoursAmplitude();
    };
    IvrDetailsComponent.prototype.handleWorkingHoursAmplitude = function () {
        var _this = this;
        // timeout is required, because workingHoursFormWrapper.form is initialized in child's onInit
        setTimeout(function () {
            _this.workingHoursFormWrapper.form.get('enabled').valueChanges.subscribe(function (value) {
                _this.amplitudeService.logEvent("Panel:Ivr:Details: Toggle working hours", { on: value });
            });
        }, 0);
    };
    IvrDetailsComponent.prototype.initEmptyForm = function () {
        this.ivr = this.route.snapshot.data['ivr'] || {
            name: ['', Validators.required],
            msisdnWelcomeMessageEnabled: [''],
            workingHours: {
                enabled: false,
                ranges: [{ hours: [defaultHours], days: defaultDays }],
                timezone: moment.tz.guess()
            },
            menus: [
                { greetingFileId: ['', Validators.required], firstLevelMenu: true, menuEntries: [[], Validators.required] }
            ]
        };
        this.ivrForm = this.formBuilder.group({
            name: ['', Validators.required],
            msisdnWelcomeMessageEnabled: [''],
            menus: this.formBuilder.array([
                this.formBuilder.group({
                    id: [],
                    greetingFileName: [],
                    greetingFileId: ['', Validators.required],
                    firstLevelMenu: [true],
                    greetingIterationsCount: [1, [Validators.required, Validators.min(0)]],
                    interGreetingPauseSecs: [10, [Validators.required, Validators.min(0)]],
                    menuEntries: this.formBuilder.array([], Validators.required)
                })
            ])
        }, { validator: this.atLeastOneFileValidator });
    };
    IvrDetailsComponent.prototype.initFormFromData = function (ivr) {
        var _this = this;
        this.ivr = this.route.snapshot.data['ivr'];
        this.ivrForm = this.formBuilder.group({
            id: [this.ivr.id, Validators.required],
            name: [this.ivr.name, Validators.required],
            msisdnWelcomeMessageEnabled: [this.ivr.msisdnWelcomeMessageEnabled],
            menus: this.formBuilder.array([
                this.formBuilder.group({
                    id: [this.ivr.menus[0].id],
                    greetingFileName: [this.ivr.menus[0].greetingFileName],
                    greetingFileId: [],
                    firstLevelMenu: [true],
                    greetingIterationsCount: [
                        this.ivr.menus[0].greetingIterationsCount,
                        [Validators.required, Validators.min(0)]
                    ],
                    interGreetingPauseSecs: [
                        this.ivr.menus[0].interGreetingPauseSecs,
                        [Validators.required, Validators.min(0)]
                    ],
                    menuEntries: this.formBuilder.array(this.ivr.menus[0].menuEntries.map(function (entry) { return _this.createIvrItemFromData(entry); }), Validators.required)
                })
            ])
        }, { validator: this.atLeastOneFileValidator });
    };
    Object.defineProperty(IvrDetailsComponent.prototype, "selectedKeys", {
        get: function () {
            return new Set(this.ivrMenuEntries.value.map(function (ivr) { return ivr.digit; }));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IvrDetailsComponent.prototype, "ivrMenuEntries", {
        get: function () {
            return this.ivrForm.get('menus.0').get('menuEntries');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IvrDetailsComponent.prototype, "ivrMenu", {
        get: function () {
            return this.ivrForm.get('menus.0');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IvrDetailsComponent.prototype, "greetingFileName", {
        get: function () {
            return this.ivr.menus[0].greetingFileName;
        },
        set: function (fileName) {
            this.ivr.menus[0].greetingFileName = fileName;
        },
        enumerable: true,
        configurable: true
    });
    IvrDetailsComponent.prototype.onSelectPhoneNumber = function (select) {
        var selectedMsisdn = select.value;
        if (!selectedMsisdn) {
            return;
        }
        this.assignedMsisdns.push(selectedMsisdn);
    };
    IvrDetailsComponent.prototype.createIvrItem = function (key) {
        this.ivrForm.get('menus.0.menuEntries').markAsTouched();
        return this.formBuilder.group({
            digit: key,
            action: ['SELECT_INBOUND', Validators.required],
            label: ['', Validators.required],
            msisdn: ['', Validators.required]
        });
    };
    IvrDetailsComponent.prototype.createIvrItemFromData = function (ivrMenuItem) {
        return this.formBuilder.group({
            digit: ivrMenuItem.digit,
            action: [ivrMenuItem.action, Validators.required],
            label: [ivrMenuItem.label, Validators.required],
            msisdn: [ivrMenuItem.msisdn, Validators.required]
        });
    };
    IvrDetailsComponent.prototype.removeIvrItem = function (index) {
        this.amplitudeService.logEvent("Panel:Ivr:Details: Remove ivr item");
        this.ivrMenuEntries.removeAt(index);
    };
    IvrDetailsComponent.prototype.onCharacterClicked = function (key) {
        if (!this.selectedKeys.has(key)) {
            this.amplitudeService.logEvent("Panel:Ivr:Details: Key clicked", { key: key });
            this.selectedKeys.add(key);
            var items = this.ivrMenuEntries;
            items.push(this.createIvrItem(key));
        }
    };
    IvrDetailsComponent.prototype.mapFormValuesToConfig = function () {
        return __assign({}, this.ivrForm.getRawValue(), { workingHours: this.workingHoursFormWrapper.form.getRawValue(), assignedMsisdns: this.assignedMsisdns });
    };
    Object.defineProperty(IvrDetailsComponent.prototype, "isFormValid", {
        get: function () {
            return (this.ivrForm.valid &&
                (!this.workingHoursFormWrapper.form ||
                    this.workingHoursFormWrapper.form.valid ||
                    !this.workingHoursFormWrapper.form.get('enabled').value));
        },
        enumerable: true,
        configurable: true
    });
    IvrDetailsComponent.prototype.onFileUploaded = function (_a) {
        var fileItem = _a.fileItem, response = _a.response;
        this.amplitudeService.logEvent('Panel:Ivr:Details: File uploaded');
        this.greetingFileId = response;
        this.temporaryFileName = fileItem && fileItem.file.name;
        this.ivrForm
            .get('menus.0')
            .get('greetingFileId')
            .setValue(response);
    };
    IvrDetailsComponent.prototype.onFileRemove = function () {
        this.amplitudeService.logEvent('Panel:Ivr:Details: File removed');
        this.greetingFileId = '';
        this.greetingFileName = '';
        this.temporaryFileName = '';
        this.ivrForm
            .get('menus.0')
            .get('greetingFileId')
            .setValue('');
        this.ivrForm
            .get('menus.0')
            .get('greetingFileId')
            .markAsTouched();
        this.ivrForm
            .get('menus.0')
            .get('greetingFileName')
            .setValue('');
        this.ivrForm
            .get('menus.0')
            .get('greetingFileName')
            .markAsTouched();
    };
    IvrDetailsComponent.prototype.markFormGroupTouched = function (formGroup) {
        var _this = this;
        Object.values(formGroup.controls).forEach(function (control) {
            control.markAsTouched();
            if (control.controls) {
                _this.markFormGroupTouched(control);
            }
        });
    };
    Object.defineProperty(IvrDetailsComponent.prototype, "shouldShowFileError", {
        get: function () {
            return ((this.ivrForm.get('menus.0').get('greetingFileId').touched ||
                this.ivrForm.get('menus.0').get('greetingFileName').touched) &&
                this.ivrForm.hasError('fileRequired'));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IvrDetailsComponent.prototype, "shouldShowKeypadError", {
        get: function () {
            return (this.ivrForm.get('menus.0.menuEntries').touched && this.ivrForm.get('menus.0.menuEntries').hasError('required'));
        },
        enumerable: true,
        configurable: true
    });
    IvrDetailsComponent.prototype.onSubmit = function () {
        if (!this.isFormValid) {
            this.amplitudeService.logEvent("Panel:Ivr:Details: " + (this.isCreatingNewIvr ? 'add' : 'update') + " submitted - validation failed");
            this.markFormGroupTouched(this.ivrForm);
            this.markFormGroupTouched(this.ivrForm.get('menus.0'));
            return;
        }
        this.amplitudeService.logEvent("Panel:Ivr:Details: " + (this.isCreatingNewIvr ? 'add' : 'update') + " submitted");
        if (this.isCreatingNewIvr) {
            this.createNewIvr();
        }
        else {
            this.updateExistingIvr();
        }
    };
    IvrDetailsComponent.prototype.updateExistingIvr = function () {
        var _this = this;
        this.ivrService.updateIvr("" + this.ivr.id, this.mapFormValuesToConfig()).subscribe(function () {
            _this.amplitudeService.logEvent("Panel:Ivr:Details: Successfully updated");
            _this.notificationService.open('IVR.SUCCESS_UPDATE_IVR');
            _this.router.navigate(['/ivr']);
        }, function () {
            _this.amplitudeService.logEvent("Panel:Ivr:Details: " + (_this.isCreatingNewIvr ? 'add' : 'update') + " error");
        });
    };
    IvrDetailsComponent.prototype.createNewIvr = function () {
        return __awaiter(this, void 0, void 0, function () {
            var limitsExceeded;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.ivrService.checkIfLimitsExceeded().toPromise()];
                    case 1:
                        limitsExceeded = _a.sent();
                        if (limitsExceeded) {
                            this.amplitudeService.logEvent("Panel:Ivr:Details: Cannot create - account limits exceeded");
                            this.ng1ModalService.lazyModalService.showUpgradeAccountModal();
                            return [2 /*return*/];
                        }
                        this.ivrService.createIvr(this.mapFormValuesToConfig()).subscribe(function (ivr) {
                            _this.notificationService.open('IVR.SUCCESS_ADD_IVR');
                            _this.amplitudeService.logEvent("Panel:Ivr:Details: Successfully added");
                            if (_this.redirectUrl) {
                                _this.ivrService.assignIvrToNumber(_this.msisdnId, "" + ivr.id).subscribe(function () {
                                    _this.router.navigateByUrl(_this.redirectUrl);
                                });
                            }
                            else {
                                _this.router.navigate(['/ivr']);
                            }
                        }, function () {
                            _this.amplitudeService.logEvent("Panel:Ivr:Details: " + (_this.isCreatingNewIvr ? 'add' : 'update') + " error");
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    return IvrDetailsComponent;
}());
export { IvrDetailsComponent };
